// Grid sizing constants for the TimeKeeping dashboard.
// Each grid column = one item slot. colWidth adapts to fill the container.
// cols changes when an item would exceed ITEM_MAX_PX (ceil threshold).
export const ITEM_BASE_PX = 60; // target item pixel width
export const ITEM_MAX_PX = 40; // upper bound — triggers a cols increment
export const ITEM_MIN_PX = 45; // lower bound — informational
// Gap between items in pixels. Must match gridConfig margin.
export const GRID_GAP = 10;

// Sentinel presenceId for logo records that have no support assigned.
// Shown as "Sin definir" in the dashboard; play button is disabled for this slot.
export const UNDEFINED_SUPPORT_ID = '__sin_definir__';

export const DEFAULT_ITEM = {
  w: 5,
  h: 10,
  min_w: 5,
  max_w: 6,
  min_h: 5,
} as const;
